import {useMutation, useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';
import {apiRoutes} from '../routes/index';
import {invalidateQueryV2} from '../services/reactQuery';
import {
  candidateListByJobKey,
  companyKeys,
  jobKeys,
} from '../services/reactQuery/cacheKey';

export const useGetEmployersQuery = (params) => {
  return useQuery(['employers', params], async () => {
    const {data} = await axiosClient.get(apiRoutes.users, {
      params: {
        ...params,
      },
    });
    return data;
  });
};

/**
 * Job - start
 */

export const useGetAllJobsQuery = (params) => {
  return useQuery(['job', params], async () => {
    const {data} = await axiosClient.get('/job', {
      params,
    });
    return data;
  });
};

export const useDeleteJobMutation = () =>
  useMutation(
    async (jobId) => {
      const {data} = await axiosClient.delete(`/job/${jobId}`);
      return data;
    },
    {
      onSuccess: () => {
        invalidateQueryV2(jobKeys.all);
      },
    },
  );

export const useGetJobDetailsQuery = (jobId) =>
  useQuery(jobKeys.detail(jobId), async () => {
    const {data} = await axiosClient.get(`/job/${jobId}`);
    return data;
  });

export const useUpdateJobMutation = () =>
  useMutation(
    async ({jobId, payload}) => {
      const {data} = await axiosClient.patch(`/job/${jobId}`, payload);
      return data;
    },
    {
      onSuccess: () => invalidateQueryV2('job'),
    },
  );

/**
 * Job - end
 */

export const useGetCandidateListByJobQuery = (jobId) =>
  useQuery(candidateListByJobKey.all(jobId), async () => {
    const {data} = await axiosClient.get(`/jobCandidate/${jobId}`);
    return data;
  });

export const useAcceptCandidateMutation = () =>
  useMutation(
    async (appliedJobId) => {
      const {data} = await axiosClient.patch(
        `/job/acceptCandidate/${appliedJobId}`,
      );
      return data;
    },
    {
      onSuccess: () => {
        invalidateQueryV2('candidateJobs');
      },
    },
  );

export const useDeclineCandidateMutation = () =>
  useMutation(
    async ({params: {jobId}, payload}) => {
      const {data} = await axiosClient.patch(
        `/job/declineCandidate/${jobId}`,
        payload,
      );
      return data;
    },
    {
      onSuccess: ({data}) => {
        invalidateQueryV2(candidateListByJobKey.all(data.jobId));
      },
    },
  );

export const useGetCompaniesDetailsQuery = () =>
  useQuery(companyKeys.all, async () => {
    const {data} = await axiosClient.get('/company');
    return data;
  });
